import { useEffect, useRef, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

interface ProgressProps {
    maxValue: number;
}

const gradientStyles = {
    path: {
        stroke: 'url(#gradient)',
    },
};

const ShowCaseProgress: React.FC<{ progress: ProgressProps }> = ({ progress }) => {
    const targetValue = 80; // Fixed progress limit
    const [progressValue, setProgressValue] = useState<number>(0);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const intersectionRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.5 }
        );

        if (intersectionRef.current) {
            observer.observe(intersectionRef.current);
        }

        return () => {
            if (intersectionRef.current) {
                observer.unobserve(intersectionRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            const interval = setInterval(() => {
                setProgressValue((prev) => Math.min(prev + 5, targetValue));
            }, 50);

            return () => clearInterval(interval);
        }
    }, [isVisible]);

    return (
        <>
            <div className="seo-progressbar" ref={intersectionRef}>
                <svg style={{ height: 0, width: 0 }}>
                    <defs>
                        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" style={{ stopColor: '#0096ff', stopOpacity: 1 }} />
                            <stop offset="100%" style={{ stopColor: '#0dcaf0', stopOpacity: 1 }} />
                        </linearGradient>
                    </defs>
                </svg>
                <CircularProgressbar
                    strokeWidth={10}
                    value={progressValue}
                    text={`${progressValue}%`}
                    styles={buildStyles({
                        pathColor: 'url(#gradient)',
                        textColor: '#000',
                    })}
                />
            </div>
        </>
    );
};

export default ShowCaseProgress;
